export const GET_UNMAPPED_POSITIONS = "GET_UNMAPPED_POSITIONS";
export const GET_UNMAPPED_POSITIONS_SUCCESS = "GET_UNMAPPED_POSITIONS_SUCCESS";
export const GET_UNMAPPED_POSITIONS_FAIL = "GET_UNMAPPED_POSITIONS_FAIL";

export const GET_UNMATCHED_CLASSIFICATIONS = "GET_UNMATCHED_CLASSIFICATIONS";
export const GET_UNMATCHED_CLASSIFICATIONS_SUCCESS = "GET_UNMATCHED_CLASSIFICATIONS_SUCCESS";
export const GET_UNMATCHED_CLASSIFICATIONS_FAIL = "GET_UNMATCHED_CLASSIFICATIONS_FAIL";

export const GET_NO_CLASSIFICATION_POSITIONS = "GET_NO_CLASSIFICATION_POSITIONS";
export const GET_NO_CLASSIFICATION_POSITIONS_SUCCESS = "GET_NO_CLASSIFICATION_POSITIONS_SUCCESS";
export const GET_NO_CLASSIFICATION_POSITIONS_FAIL = "GET_NO_CLASSIFICATION_POSITIONS_FAIL";

export const GET_CLASSIFICATIONS_LOOKUP = "GET_CLASSIFICATIONS_LOOKUP";
export const GET_CLASSIFICATIONS_LOOKUP_SUCCESS = "GET_CLASSIFICATIONS_LOOKUP_SUCCESS";
export const GET_CLASSIFICATIONS_LOOKUP_FAIL = "GET_CLASSIFICATIONS_LOOKUP_FAIL";

export const PROPOSE_POSITION_MAPPING = "PROPOSE_POSITION_MAPPING";
export const PROPOSE_POSITION_MAPPING_SUCCESS = "PROPOSE_POSITION_MAPPING_SUCCESS";
export const PROPOSE_POSITION_MAPPING_FAIL = "PROPOSE_POSITION_MAPPING_FAIL";

export const GET_PENDING_POSITION_MAPPINGS = "GET_PENDING_POSITION_MAPPINGS";
export const GET_PENDING_POSITION_MAPPINGS_SUCCESS = "GET_PENDING_POSITION_MAPPINGS_SUCCESS";
export const GET_PENDING_POSITION_MAPPINGS_FAIL = "GET_PENDING_POSITION_MAPPINGS_FAIL";

export const DECIDE_POSITION_MAPPING = "DECIDE_POSITION_MAPPING";
export const DECIDE_POSITION_MAPPING_SUCCESS = "DECIDE_POSITION_MAPPING_SUCCESS";
export const DECIDE_POSITION_MAPPING_FAIL = "DECIDE_POSITION_MAPPING_FAIL";

export const GET_MY_MAPPING_HISTORY = "GET_MY_MAPPING_HISTORY";
export const GET_MY_MAPPING_HISTORY_SUCCESS = "GET_MY_MAPPING_HISTORY_SUCCESS";
export const GET_MY_MAPPING_HISTORY_FAIL = "GET_MY_MAPPING_HISTORY_FAIL";
